import Vue from 'vue'
import ResourceService from './resource.service'

class DriverService extends ResourceService {
  static get resource() {
    return 'driver'
  }

  static ratingDetails(driverID, rateNumber, params = {}) {
    const url = `${this.resource}/${driverID}/rating-details/${rateNumber}`
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(url, { params })
        .then(({ data }) => {
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  static rating(driverID) {
    const url = `${this.resource}/${driverID}/rating`
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(url)
        .then(({ data }) => {
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  static download(params = {}) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(`${this.resource}/download`, {
          responseType: 'blob',
          params,
        })
        .then(({ data }) => {
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

static branchGarages(branchId, params = {}) {
  const url = `branch/${branchId}/garages`

  return Vue.axios
    .get(url, {
      params: {
        limit: 100,
        ...params,
      },
    })
    .then((res) => res.data)
}
  static branchwaterSource(branchId, params = {}) {
    const url = `branch/${branchId}/water-sources`
    return Vue.axios.get(url, { params }).then((res) => res.data)
  }
  static ratingSummary(driverID, params = {}) {
    const url = `rating/${this.resource}/${driverID}/summary`
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(url, { params })
        .then(({ data }) => {
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
  static ratingByDriver(driverID, params = {}) {
    const url = `rating`
    return Vue.axios.get(url, { params: { driver: driverID, ...params } }).then((res) => res.data)
  }
}

export default DriverService
